module.exports = __webpack_public_path__ + "img/news_banner.a945eec2.jpg";